import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  title: {
    fontSize: '20px !important'
  },
  formWrapper: {
    backgroundColor: `${token.primary.primary3}1A`, // 0.1 opacity
    borderRadius: 6,
    padding: '24px 12px'
  }
}))
